import { render } from "./Login.vue?vue&type=template&id=cf03d55e&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=cf03d55e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf03d55e"]])

export default __exports__